module.exports = __webpack_public_path__ + "0a917e1390228b874bccfacec4f40398.MP3";